import mime from 'mime-types';
//
export default class Utils {}
//
Utils.dataURItoBlob = function(dataURI) { //got from https://gist.github.com/davoclavo/4424731
  console.log(dataURI.replace(/^data:image\/\w+;base64,/, "").replace(/^data:application\/[\w\[.\-\]\\]+;base64,/, ""))
  return Buffer.from(dataURI.replace(/^data:image\/\w+;base64,/, "").replace(/^data:application\/[\w\[.\-\]\\]+;base64,/, ""), 'base64');
};
Utils.getFileExtensionFromMimeType = function (mimeType) {
  return mime.extension(mimeType);
};
Utils.splitFilenameAndExtension = function (fileName) {
  const splittedName = fileName ? fileName.split('.') : '';
  const extension = splittedName ? splittedName[splittedName.length - 1] : '';
  const filename = fileName ? fileName.slice(0, -(extension.length + 1)) : '';
  return { filename, extension };
};